import { render, staticRenderFns } from "./RouterQueueTrigger.vue?vue&type=template&id=df71fd14"
import script from "./RouterQueueTrigger.vue?vue&type=script&lang=js"
export * from "./RouterQueueTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports